import React, { Component } from 'react'
import Tooltip from '@mui/material/Tooltip';
import CircularProgress from '@mui/material/CircularProgress';
import DoneOutlined from '@mui/icons-material/DoneOutlined';
import MoreHorizOutlined from '@mui/icons-material/MoreHorizOutlined';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

class ProgressIndicator extends Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  componentDidMount() {
    this.setState({isCompleted: this.props.progress === 100})
  }

  componentWillReceiveProps(newProps) {
    this.setState({isCompleted: newProps.progress === 100})
  }

  render() {
    const { progress } = this.props;
    const { isCompleted } = this.state;
    const color = progress > 50 ? 'seagreen' : 'orangered';

    // 'currentColor' erbt die Textfarbe des Themes und funktioniert damit in
    // beiden Farbmodi; die Deckkraft macht den Punkt gedimmt.
    const dotColor = (progress === 'empty' || progress === -1) ? 'currentColor'
      : isCompleted && !this.props.outOfSync ? 'seagreen'
      : this.props.outOfSync ? 'orange'
      : color;
    const dotOpacity = progress === 'empty' ? 0.25
      : progress === -1 ? 0.35
      : 1;
    // -1 (not calculated yet) pushed the ring's dash offset past a full turn and left a one-pixel
    // sliver of the value colour; the ring draws nothing until a real percentage arrives
    const ringValue = Math.max(0, Math.min(100, Number(progress) || 0));

    if(progress === 'empty') {
      return (
        <span className="progress-indicator" style={{position: 'absolute', top: 20, left: 24}}>
          <span className="progress-full">
            <CircularProgress
              variant="determinate"
              value={100}
              style={{opacity: .25, color: 'currentColor'}}
              size={24}
            />
            <span style={{position: 'absolute', top: 1, left: 4, opacity: .25}}>
              <DoneOutlined style={{fontSize: 16}} />
            </span>
          </span>
          <span className="progress-dot" style={{backgroundColor: dotColor, opacity: dotOpacity}} />
        </span>
      )
    } else {
      return (
        <span className="progress-indicator" style={{position: 'absolute', top: 20, left: 24}}>
          <span className="progress-full">
            <CircularProgress
              variant="determinate"
              value={100}
              style={{position: 'absolute', top: 0, left: 0, opacity: .25, color: 'currentColor'}}
              size={24}
            />
            <CircularProgress
              variant="determinate"
              value={ringValue}
              style={{position: 'absolute', top: 0, left: 0, color}}
              size={24}
            />
            {isCompleted && !this.props.outOfSync ?
              (<span style={{position: 'absolute', top: 1, left: 4, color: 'seagreen'}}>
                <DoneOutlined style={{fontSize: 16}} />
              </span>) : null
            }
            {this.props.outOfSync &&
              <span style={{position: 'absolute', top: 1, left: 4}}>
                <MoreHorizOutlined style={{fontSize: 16}} />
              </span>
            }
            {progress === -1 &&
              <Tooltip title="Progress will be calculated when the item is opened." placement="top" arrow>
                <FiberManualRecordIcon style={{position: 'absolute', left: 0, top: 0, opacity: .5}} />
              </Tooltip>
            }
          </span>
          <span className="progress-dot" style={{backgroundColor: dotColor, opacity: dotOpacity}} />
        </span>
      )
    }
  }
}

export default ProgressIndicator;
